import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RingLoader from 'react-spinners/RingLoader';
import * as actions from './redux/actions';

const css = {
  margin: 'auto',
  marginTop: 'revert',
  display: 'block',
};

export class LoaderScreen extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    const { editor, iconSize, iconColor, message, messageColor } = this.props;
    const { showBuilderCanvasLoader } = editor || false;
    if (showBuilderCanvasLoader) {
      return (
        <div className="gjs-mdl-container" style={{ backgroundColor: 'rgba(48, 52, 83, 0.9)' }}>
          <div
            className="gjs-mdl-dialog gjs-two-color"
            style={{ maxWidth: '100%', marginLeft: '5em' }}
          >
            <div className="gjs-mdl-header" style={{ visibility: 'hidden' }}>
              <div className="gjs-mdl-title" style={{ textAlign: 'center' }}>
                Welcome to{' '}
                {process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION' ? 'DrapCode' : 'Webconnect'}{' '}
                Builder!
              </div>
            </div>
            <div className="gjs-mdl-content">
              <div id="gjs-mdl-c" className="p-5" style={{ textAlign: 'center' }}>
                <RingLoader
                  css={css}
                  size={iconSize || '80px'}
                  color={iconColor || '#fdfdfd'}
                  loading={true}
                />
              </div>
              <div className="p-3" style={{ textAlign: 'center' }}>
                <h2 style={{ color: `${messageColor || '#fdfdfd'}` }}>
                  {message || 'Please wait while we finish loading Builder Components...'}
                </h2>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return '';
    }
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
    editor: state.editor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoaderScreen);
